import { useRef, useCallback } from 'react'

import useWillUnmount from './useWillUnmount'


const useTimer = ({ delay, callback }) => {
  const timer = useRef(null)

  const setTimer = useCallback(() => {
    timer.current = setTimeout(callback, delay)
  }, [ callback, delay ])

  const clearTimer = useCallback(() => {
    if (timer.current) {
      clearTimeout(timer.current)
      timer.current = null
    }
  }, [])

  useWillUnmount(clearTimer)

  return { setTimer, clearTimer, timer: timer.current }
}


export default useTimer
